export const HISTORY_ITME = [
    {
        year:"2017",
        month:"11월",
        content:"1기 11명 선발",
    },
    {
        year:"2018",
        month:"2월",
        content:"T-Messenge 개발 발표 - 대상: 전학생, 장소: 시청각실",
    },
    {
        year:"2019",
        month:"3월",
        content:"도담도담 학생생활관리시스템 개발 시작",
    },
    {
        year:"2020",
        month:"6월",
        content:"도담도담 교내 베타테스트 시작",
    },
    {
        year:"2021",
        month:"1월",
        content:"도담도담 iOS 버전(학생용) 베타 테스트 시작",
    },
    {
        year:"2024",
        month:"3월",
        content:"B1ND 8기 출범",
    },
    {
        year:"",
        month:"",
        content: "\"후배들을 위해 선배가\" 교육 프로그램 단디 실시",
    },
    {
        year:"",
        month:"5월",
        content:"도담도담 사용자 피드백 반영",
    },
    {
        year:"",
        month:"6월",
        content:"2024 B1CODE SUMMER 개최",
    },
    {
        year:"",
        month:"10월",
        content:"도담도담 Parent 개발 시작",
    },
    {
        year:"",
        month:"12월",
        content:"2024 B1CODE WINTER 개최",
    },
    {
        year:"2025",
        month:"3월",
        content:"도담도담 Parent 출시",
    },
    
]